import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcpProgressBarComponent } from './fcp-progress-bar.component';
import { FcpIconModule } from '../fcp-icon';

@NgModule({
    declarations: [FcpProgressBarComponent],
    imports: [CommonModule, FcpIconModule],
    exports: [FcpProgressBarComponent]
})
export class FcpProgressBarModule {}
